const FishCalculatorModal = () => {
    const modals = document.querySelectorAll('.fish-calculator-modal').forEach(modal => {
        let panel1 = modal.querySelector('.panel-1');
        let panel2 = modal.querySelector('.panel-2');
        let rangeInputs = modal.querySelectorAll('.radio-input');
        let answers = modal.querySelectorAll('.answer');

        // Update the answers when a radio button is selected
        rangeInputs.forEach(input => {
            input.addEventListener('change', () => {
                answers.forEach(answer => {
                    answer.classList.remove('show');
                    if (answer.getAttribute('data-rangeid') === input.id) {
                        answer.classList.add('show');
                    }
                })
            })
        })

        // Set it to the first panel when the modal is closed
        modal.addEventListener('hidden.bs.modal', function (e) {
            panel2.classList.remove('show');
            panel1.classList.add('show');
        })

        // Toggle the panels when the toggle button is clicked
        modal.querySelectorAll('.btn-toggle-panels').forEach(button => {
            button.addEventListener('click', () => {
                if (panel1.classList.contains('show')) {
                    panel1.classList.remove('show');
                    panel2.classList.add('show');
                } else {
                    panel2.classList.remove('show');
                    panel1.classList.add('show');
                }
            })
        })
    })
}

export default FishCalculatorModal;